import type { PerPromptStat } from '@ekorank/shared'

interface Props {
  perPrompt: PerPromptStat[]
}

export function PromptPerformance({ perPrompt }: Props) {
  if (perPrompt.length === 0) return null

  return (
    <div className="bg-surface-container rounded-xl border border-outline-variant/10 p-4 sm:p-6 mb-6 sm:mb-10">
      <h3 className="text-sm font-mono text-outline uppercase tracking-widest mb-1">Prompt Performance</h3>
      <p className="text-xs text-outline mb-6">Sorted weakest first — gaps are at the top</p>
      <ul className="space-y-3">
        {perPrompt.map((p) => (
          <li key={p.promptId} className="space-y-1.5">
            <div className="flex items-baseline justify-between gap-3">
              <p className="text-sm text-white truncate flex-1">{p.promptText}</p>
              <p className="text-xs font-mono text-on-surface-variant whitespace-nowrap">
                {p.mentions}/{p.checks} ({p.mentionRate}%)
              </p>
            </div>
            <div className="h-1.5 rounded-full bg-surface-container-high overflow-hidden">
              <div
                className={`h-full rounded-full ${p.mentionRate >= 50 ? 'bg-secondary' : p.mentionRate > 0 ? 'bg-primary/60' : 'bg-error/40'}`}
                style={{ width: `${p.mentionRate}%` }}
              />
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}
